import { API_ENDPOINTS } from "config/config";

export const DEFAULT_FC_MOTIVATE_PERCENT = 20;
export const DEFAULT_EMAIL_MANAGER_PERCENT = 20;
export const DEFAULT_ACE_PERFORMANCE_PERCENT = 10;
export const DEFAULT_SALE_TEAM_PERCENT = 30;
export const DEFAULT_SALE_TEAM_5K_PERCENT = 17.5;

export const COMMISSION_PERCENT_DEFAULTS = {
  fcMotivatePercentage: DEFAULT_FC_MOTIVATE_PERCENT,
  emailManagerPercentage: DEFAULT_EMAIL_MANAGER_PERCENT,
  acePerformancePercentage: DEFAULT_ACE_PERFORMANCE_PERCENT,
  saleTeamPercentage: DEFAULT_SALE_TEAM_PERCENT,
  saleTeam5kPercentage: DEFAULT_SALE_TEAM_5K_PERCENT,
};

export const parsePercent = (value, fallback = 0) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
};

export const parseFcMotivatePercent = (value) =>
  parsePercent(value, DEFAULT_FC_MOTIVATE_PERCENT);

export const normalizeCommissionConfig = (config = {}) => ({
  fcMotivatePercentage: parsePercent(
    config.fcMotivatePercentage,
    DEFAULT_FC_MOTIVATE_PERCENT
  ),
  emailManagerPercentage: parsePercent(
    config.emailManagerPercentage,
    DEFAULT_EMAIL_MANAGER_PERCENT
  ),
  acePerformancePercentage: parsePercent(
    config.acePerformancePercentage,
    DEFAULT_ACE_PERFORMANCE_PERCENT
  ),
  saleTeamPercentage: parsePercent(
    config.saleTeamPercentage,
    DEFAULT_SALE_TEAM_PERCENT
  ),
  saleTeam5kPercentage: parsePercent(
    config.saleTeam5kPercentage,
    DEFAULT_SALE_TEAM_5K_PERCENT
  ),
});

export const getConfig = async (api) => {
  const response = await api.get(API_ENDPOINTS.GET_CONFIG);
  return normalizeCommissionConfig(response.data.data);
};

export const updateConfig = async (api, payload) => {
  const response = await api.put(API_ENDPOINTS.UPDATE_CONFIG, payload);
  return {
    ...response.data,
    data: normalizeCommissionConfig(response.data?.data),
  };
};

/** PUT /config — update any commission percentage fields */
export const updateCommissionSettings = (api, data) => updateConfig(api, data);

/** @deprecated Prefer updateCommissionSettings / updateConfig */
export const updateFcMotivatePercentage = async (api, fcMotivatePercentage) => {
  const response = await api.put(API_ENDPOINTS.UPDATE_FC_MOTIVATE_PERCENTAGE, {
    fcMotivatePercentage,
  });
  return {
    ...response.data,
    data: normalizeCommissionConfig(response.data?.data),
  };
};
